import { render, staticRenderFns } from "./ModalRecursos.vue?vue&type=template&id=99f0ad9c&"
import script from "./ModalRecursos.vue?vue&type=script&lang=js&"
export * from "./ModalRecursos.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecursos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports